import { nanoid } from 'nanoid'
import { useCallback, useState } from 'react'
import { LittleModalCreateEdit } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import useShortcuts from '../../../../../../../../utils/hooks/useShorcuts'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getEmployeeQuickAccessParam } from '../../../../../../../../utils/reducers/getters'
import { changeEmployeeParams } from '../../../../../../../../utils/reducers/reduxDispatch'


interface ModalCEEmployeeQuickAccessProps extends ModalCEEmployeQuickAccessLogicProps { }

const ModalCEEmployeeQuickAccess: React.FC<ModalCEEmployeeQuickAccessProps> = ({ allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { beforeSubmit, setMyAction, myAction } = useModalCEEmployeQuickAccessLogic({ ...rest })
    const { shortcuts } = useShortcuts()
  
    const fields: FormRender<TwinDictionary> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'icon',
                    label: t('icon', 'Icono'),
                    component: 'InputIconWithMargin',
                    defaultValue: allRowData?.icon,
                    required: true
                },
                {
                    name: 'name',
                    label: t('accessName','Nombre del acceso'),
                    component: 'InputWithLabelMargin',
                    required: true
                },
                {
                    name: 'action',
                    label: t('action','Acción'),
                    items: shortcuts,
                    component: 'CustomSelectWithSearchBar',
                    required: true,
                    onChange: (value) => setMyAction(value),
                    value: myAction || ''
                },
            ]
        },
    ]
    if (myAction === 'navigate') {
        fields[0].elements.push({
            name: 'actionParams',
            label: t('navigate', 'Navegar a'),
            component: 'InputWithLabelMargin',
            required: true
        })
    }
    
    return (
        <LittleModalCreateEdit fields={fields} url={''} translations={{
            title: t('createQuickAccess', 'Crear acceso rápido'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} {...rest} beforeSubmit={(values) => { beforeSubmit(values); return false }} />
    )
}

interface ModalCEEmployeQuickAccessLogicProps extends ModalEditComponentProps {} 

const useModalCEEmployeQuickAccessLogic = ({ setOpened, onSubmit }: ModalCEEmployeQuickAccessLogicProps) => {
    const [myAction, setMyAction] = useState<string | null>(null)

    const beforeSubmit = useCallback(async (values: TwinDictionary) => {
        const employeeParameter = getEmployeeQuickAccessParam()
        const newShortcut = {
            icon: values.icon,
            name: values.name,
            id: nanoid(),
            order: employeeParameter.length+1,
            action: values.action,
            actionParams: values.actionParams
        }
        employeeParameter.push(newShortcut)

        const shortcutsStr = JSON.stringify(employeeParameter)
        const result = await twinFetchPostJSON('/api/app/config/employee/updateEmployeeParameter', { parameterKey: 'employee_quick_access', value: shortcutsStr })
        changeEmployeeParams({ 'employee_quick_access': shortcutsStr })
        setOpened(null)
        onSubmit(result, employeeParameter)
    }, [setOpened, onSubmit])

    return { beforeSubmit, myAction, setMyAction }
}

export default ModalCEEmployeeQuickAccess